/** Geometry and timing every recharts card in this design shares. */
export const CHART_HEIGHT = 300;
export const CHART_BAR_RADIUS = 4;
export const CHART_DRAW_DURATION = 1400;
